module.exports = __webpack_public_path__ + "media/src/images/organisation_purchase-1e3caf007f6aa7d2eefadf72c703cb6f.jpg";